<template>
  <div class="page">
    <div class="heading">
      <v-toolbar :flat="flatapp" dense>
        <v-btn icon @click="menulink">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <v-breadcrumbs
            :items="crumbs"
            class="capitalize"
            style="padding: 14px 20px"
        >
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
        <v-spacer></v-spacer>
        <v-btn color="primary" text x-small @click.stop="newDialog = true">
          new service
        </v-btn>
        <ServiceNew
            :newDialog="newDialog"
            @closeNew="closeNew"
            @submitNew="submitNew"
        />
        <v-btn color="primary" icon @click="refresh">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </div>

    <div class="body">
      <v-card flat>
        <v-card-text>
          <v-data-table
              :headers="headers"
              :items="servicelist"
              :items-per-page="10"
              :loading="loading"
              loader-height="1"
          >
            <template v-slot:item.description="{ item }">
              {{ truncateString(item.description, 30) }}
            </template>

            <template v-slot:item.updated="{ item }">
              {{ item.updated | myDating }}
            </template>

            <template v-slot:item.id="{ item }">
              <v-btn
                  color="primary"
                  text
                  x-small
                  @click.stop="$set(viewDialog, item.id, true)"
              >
                view
              </v-btn>
              <ServiceView
                  v-if="viewDialog[item.id]"
                  :myId="item.id"
                  :viewDialog="viewDialog[item.id]"
                  @closeView="closeView"
              />

              <v-btn
                  color="success"
                  text
                  x-small
                  @click.stop="$set(editDialog, item.id, true)"
              >
                edit
              </v-btn>
              <ServiceEdit
                  v-if="editDialog[item.id]"
                  :editDialog="editDialog[item.id]"
                  :myId="item.id"
                  @closeEdit="closeEdit"
                  @submitEdit="submitEdit"
              />

              <v-btn
                  color="error"
                  text
                  x-small
                  @click.stop="$set(removeDialog, item.id, true)"
              >
                delete
              </v-btn>
              <ServiceRemove
                  v-if="removeDialog[item.id]"
                  :myId="item.id"
                  :removeDialog="removeDialog[item.id]"
                  @closeRemove="closeRemove"
                  @submitRemove="submitRemove"
              />
            </template>
            <!-- truncateString -->
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-snackbar
          v-model="snack.bar"
          :color="snack.color"
          :multi-line="snack.multiLine"
      >
        {{ snack.text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snack.bar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import Restful from "@/services/RestFul";
import WinScroll from "../../mixins/windowscroll";
import Utils from "../../mixins/utils";
import ServiceNew from "../../components/subsidiaries/services/newone.vue";
import ServiceEdit from "../../components/subsidiaries/services/edit.vue";
import ServiceView from "../../components/subsidiaries/services/view.vue";
import ServiceRemove from "../../components/subsidiaries/services/remove.vue";

export default {
  components: {ServiceNew, ServiceEdit, ServiceView, ServiceRemove},
  mixins: [Utils, WinScroll("position")],
  data() {
    return {
      editDialog: {},
      viewDialog: {},
      removeDialog: {},
      snack: {
        color: "info",
        multiLine: true,
        bar: false,
        text: "Processing ... ",
      },
      loading: false,
      newDialog: false,
      crumbs: [
        {
          link: true,
          text: "Dashboard",
          to: {name: "lab.dash"},
        },
        {
          link: true,
          text: "Services",
          to: {name: "lab.services"},
        },
      ],
      servicelist: [],
      headers: [
        {text: "service", value: "service"},
        {text: "description", value: "description"},
        {text: "updated", value: "updated"},
        {text: "action", value: "id"},
      ],
    };
  },
  computed: {
    flatapp: function () {
      if (this.position[1] > 30) {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    this.list();
  },
  methods: {
    list() {
      this.loading = true;
      let self = this;
      Restful.subscribers.services
          .list()
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              this.servicelist = response.data;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log(error.response);
            self.loading = false;
          });
    },
    refresh() {
      this.list();
    },
    menulink() {
      this.$emit("sidebar");
    },
    closeNew(p) {
      this.newDialog = p.state;
    },
    submitNew(p) {
      this.snack.bar = true;
      console.log(p);
      let self = this;
      Restful.subscribers.services
          .create(p.data)
          .then((response) => {
            // console.log(response.data);
            this.snack.color = "success";
            this.snack.text = response.data;
            this.list();
          })
          .catch((error) => {
            console.log(error.response);
            self.snack.color = "error";
            self.snack.text = error.response.data;
          });
      this.newDialog = p.state;
    },
    closeEdit(p) {
      this.$set(this.editDialog, p.id, p.state);
    },
    submitEdit(p) {
      this.snack.bar = true;
      console.log(p);
      let self = this;
      Restful.subscribers.services
          .update(p.id, p.data)
          .then((response) => {
            // console.log(response.data);
            this.snack.color = "success";
            this.snack.text = response.data;
            this.list();
          })
          .catch((error) => {
            console.log(error.response);
            self.snack.color = "error";
            self.snack.text = error.response.data;
          });
      this.$set(this.editDialog, p.id, p.state);
    },
    closeView(p) {
      this.$set(this.viewDialog, p.id, p.state);
    },
    closeRemove(p) {
      this.$set(this.removeDialog, p.id, p.state);
    },
    submitRemove(p) {
      this.snack.bar = true;
      console.log(p);
      let self = this;
      Restful.subscribers.services
          .remove(p.id)
          .then((response) => {
            // console.log(response.data);
            this.snack.color = "success";
            this.snack.text = response.data;
            this.list();
          })
          .catch((error) => {
            console.log(error.response);
            self.snack.color = "error";
            self.snack.text = error.response.data;
          });
      this.$set(this.removeDialog, p.id, p.state);
    },
  },
};
</script>
